import { Field, ID, InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { AddChatMessageArgs } from '../../chat/args/AddChatMessageArgs'
import type { ChatMessage } from '../../chat/Chat'

/**
 * We just need to extend AddChatMessageArgs to include the information related to the orderId
 */
@InputType()
export class AddOrderChatMessageArgs extends AddChatMessageArgs {
  // Overrides the base's optional orderId with a required one (declare-override — same idiom as User._id/status).
  @Field(() => ID)
  declare orderId: string
}

export interface IAddOrderChatMessage extends IAction<ChatMessage, AddOrderChatMessageArgs> {}
